export default __webpack_public_path__ + "static/media/image-cover.31b82f5a.png";